import { colors, FlexContainer, Text } from '@/components'
import { InstructionIconProps } from './InstructionIcons'
import * as styles from './InstructionRow.styles'

type InstructionRowProps = {
  Icon: React.ComponentType<InstructionIconProps>
  text: string
}

const InstructionRow = ({ Icon, text }: InstructionRowProps) => (
  <FlexContainer
    align="center"
    css={styles.instructionsRowContainer}
    flexWrap="nowrap"
  >
    <FlexContainer css={styles.instructionsIconContainer}>
      <Icon fill={colors.grey.c800} iconCss={styles.instructionsIcon} />
    </FlexContainer>
    <Text align="start">{text}</Text>
  </FlexContainer>
)

export default InstructionRow
